<template>
  <div class="modal fade" id="modal_waiting_list" data-bs-keyboard="false"
       data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl" style="max-width: 90%;">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="fw-bolder" data-kt-calendar="title">
            Lista de espera
          </h2>

          <button data-bs-toggle="collapse" href="#collapseWaitingList" id="btnCollapseWaitingList" role="button"
                  aria-expanded="false"
                  @click="creatingOrUpdating = !creatingOrUpdating"
                  aria-controls="collapseWaitingList" class="btn"
                  :class="creatingOrUpdating ? 'btn-secondary' : 'btn-success'">
            {{ creatingOrUpdating ? 'Cancelar' : 'Adicionar' }}
          </button>

          <div class="btn btn-icon btn-sm btn-active-icon-primary"
               data-bs-dismiss="modal" aria-label="Fechar">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                     fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="black"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="black"/>
                </svg>
              </span>
          </div>
        </div>
        <div class="modal-body pt-1">
          <form @submit.prevent="onSubmit">
            <div id="collapseWaitingList" class="collapse row">
              <div class="col-md-5">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2" for="id_prof">Profissional</label>
                  <Dropdown :options="professionals"
                            :filter="true"
                            appendTo="self"
                            :disabled="this.form.id_wl != null"
                            @change="onChangeProf($event.value);"
                            v-model="form.id_prof"
                            optionLabel="prof_name"
                            optionValue="id_prof"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="id_prof"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Profissional"
                            style="display: flex;"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2">Especialidade</label>
                  <Dropdown :options="specialties"
                            :filter="true"
                            appendTo="self"
                            v-model="form.id_spec"
                            :disabled="this.form.id_wl != null"
                            optionLabel="spec_name"
                            optionValue="id_spec"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="id_spec"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Especialidades"
                            style="display: flex;"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="fv-row">
                  <label class="fs-6 fw-bold mb-2 required">Forma de recebimento</label>
                  <Dropdown :options="paymentMethods"
                            v-model="form.id_paymeth"
                            optionLabel="paymeth_name"
                            optionValue="id_paymeth"
                            appendTo="self"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="id_paymeth"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Forma de recebimento"
                            style="display: flex;"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="fv-row">
                  <label class="fs-6 fw-bold required mb-2">Paciente</label>
                  <SearchPatient v-model="form.wl_name" :disabled="this.form.id_wl != null"
                                 :value="form.wl_name"
                                 :professionalId="parseInt(form.id_prof)"
                                 :key="form.id_prof + '-' + uniqueKey"
                                 @onInput="onClickSearchedPatient"
                                 @onClick="onClickSearchedPatient"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="fv-row">
                  <PatientIdentityFields :form="form" cpf-field="wl_cpf"
                    :disabled="form.id_wl != null" allow-select @select="onClickSearchedPatient" />
                </div>
              </div>

              <div class="col-md-3">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2">Data Nascimento</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="'##/##/####'" required
                         placeholder="DD/MM/YYYY" v-model="form.wl_dt_birth"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2">Telefone</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="['(##) ####-####', '(##) #####-####']" required
                         placeholder="(99) 9 9999-9999" v-model="form.wl_phone"/>
                </div>
              </div>

              <div class="col-md-8" v-show="allowInsurance()">
                <div class="fv-row">
                  <label class="fs-6 fw-bold mb-2">Convênio</label>
                  <Dropdown :options="insurances"
                            :filter="true"
                            appendTo="self"
                            v-model="form.id_insurance"
                            optionLabel="insurance_name"
                            optionValue="id_insurance"
                            :filter-fields="['insurance_name', 'trading_name']"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="id_insurance"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Convênio"
                            style="display: flex;"
                  >
                    <template #option="slotProps">
                      <div class="flex align-items-center text-truncate w-75">
                        <div v-if="slotProps.option.trading_name">
                          {{ slotProps.option.trading_name }}
                          -
                          {{ slotProps.option.insurance_name }}
                        </div>
                        <div v-else>
                          {{ slotProps.option.insurance_name }}
                        </div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2 required">
                  Data limite
                  <i class="bi bi-info-circle" title="Até qual dia o paciente ficará na lista de espera."></i>
                </label>
                <Calendar class="fw-bold form-control-sm form-control" v-model="form.wl_wait_at"
                          placeholder="DD/MM/YYYY"
                          dateFormat="dd/mm/yy" :min-date="new Date()"
                />
              </div>
              <div class="col-md-12">
                <label class="fs-6 fw-bold mb-2">Observação</label>
                <textarea class="form-control form-control-solid"
                          v-model="form.wl_obs"
                          placeholder="Observação da consulta"/>
              </div>

              <div class="col-md-12 text-end">
                <br>
                <button type="submit" class="btn btn-primary">Salvar lista de espera</button>
              </div>
            </div>
          </form>
          <hr>
          <div v-show="!creatingOrUpdating">
            <div class="row">
              <p class="mb-2">Filtrar lista de espera: </p>
              <div class="col-md-6">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2" for="filter_id_prof">Profissional</label>
                  <Dropdown :options="professionals"
                            :filter="true"
                            appendTo="self"
                            showClear
                            @change="onFilterProfChange($event.value)"
                            v-model="filter.id_prof"
                            optionLabel="prof_name"
                            optionValue="id_prof"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="filter_id_prof"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Profissional"
                            style="display: flex;"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="fv-row">
                  <label class="fs-6 required fw-bold mb-2" for="filter_id_spec">Especialidade</label>
                  <Dropdown :options="filterSpecialties"
                            :filter="true"
                            appendTo="self"
                            showClear
                            @change="getWaitingLists()"
                            v-model="filter.id_spec"
                            optionLabel="spec_name"
                            optionValue="id_spec"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="filter_id_spec"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Especialidades"
                            style="display: flex;"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12">
                <div class="fv-row">
                  <label class="fs-6 fw-bold mb-2" for="filter_id_insurance">Convênio</label>
                  <Dropdown :options="placeInsurances"
                            :filter="true"
                            appendTo="self"
                            showClear
                            @change="getWaitingLists()"
                            v-model="filter.id_insurance"
                            optionLabel="insurance_name"
                            optionValue="id_insurance"
                            :filter-fields="['insurance_name', 'trading_name', 'place_insurance.nick_name']"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            id="filter_id_insurance"
                            class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                            placeholder="Convênio"
                            style="display: flex;"
                  >
                    <template #option="slotProps">
                      <div class="flex align-items-center text-truncate w-75">
                        <div v-if="slotProps.option?.place_insurance?.nick_name">
                          {{ slotProps.option.place_insurance.nick_name }}
                          -
                          {{ slotProps.option.insurance_name }}
                        </div>
                        <div v-else-if="slotProps.option?.trading_name">
                          {{ slotProps.option.trading_name }}
                          -
                          {{ slotProps.option.insurance_name }}
                        </div>
                        <div v-else>
                          {{ slotProps.option.insurance_name }}
                        </div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div class="row mb-3 align-items-end mt-5">
              <div class="col-md-6 d-flex align-items-center gap-2 flex-wrap">
                <span v-if="selectedIds.length > 0" class="badge badge-light-primary fs-7">
                  {{ selectedIds.length }} selecionado(s)
                </span>
                <button v-if="selectedIds.length > 0"
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="removeSelectedWaitingLists">
                  <i class="bi bi-trash"></i> Remover selecionados
                </button>
              </div>
              <div class="col-md-6 text-end">
                <button v-if="waitingLists.length > 0"
                        type="button"
                        class="btn btn-warning me-2"
                        :disabled="selectedIds.length === 0 || notifying"
                        title="Avisar horário disponível para os pacientes selecionados"
                        @click="notifyWaitingLists">
                  <i class="bi bi-whatsapp"></i> Avisar selecionados
                </button>
                <button class="btn btn-primary" @click="exportWaitingList" title="Exportar lista filtrada em CSV">
                  <i class="bi bi-download"></i> Exportar CSV
                </button>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="table-responsive waiting-list-table-scroll">
                <table class="table gs-7 gy-7 gx-7">
                  <thead>
                  <tr class="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <th scope="col" style="width: 40px;">
                      <input type="checkbox"
                             class="form-check-input"
                             :checked="isAllSelected"
                             :indeterminate.prop="isPartiallySelected"
                             @change="toggleSelectAll">
                    </th>
                    <th scope="col">Paciente</th>
                    <th scope="col">Profissional</th>
                    <th scope="col">Convênio</th>
                    <th scope="col">Obs</th>
                    <th scope="col">Data Cadastro</th>
                    <th scope="col">Data Limite</th>
                    <th scope="col">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="waitingList in waitingLists" :key="waitingList.id_wl">
                    <td>
                      <input type="checkbox"
                             class="form-check-input"
                             :checked="selectedIds.includes(waitingList.id_wl)"
                             @change="toggleSelect(waitingList.id_wl)">
                    </td>
                    <th>{{ waitingList.wl_name }} <br><b>Fone:</b> {{ waitingList.wl_phone }}</th>
                    <td>{{ waitingList.professional?.prof_name }}</td>
                    <td>{{ waitingList.insurance?.insurance_name }}</td>
                    <td>{{ waitingList.wl_obs }}</td>
                    <td>{{ this.date(waitingList.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                    <td>{{ this.date(waitingList.wl_wait_at).format('DD/MM/YYYY') }}</td>
                    <td>
                      <div class="btn-group" role="group">
                        <button class="btn btn-sm btn-info" title="Editar lista de espera"
                                @click="editWaitingList(waitingList)">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button class="btn btn-sm btn-success" title="Transformar em agendamento"
                                @click="scheduleFromWaitingList(waitingList)">
                          <i class="bi bi-plus-circle"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" title="Remover paciente da lista de espera"
                                @click="removeWaitingList(waitingList.id_wl)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { patientIdentity } from "@/helpers/patientIdentity";
import SearchPatient from "../../components/SearchPatient.vue";
import http from "../../helpers/http";
import {mask} from "vue-the-mask";
import Modal from "../../helpers/modal";
import Dropdown from "primevue/dropdown";
import Alert from "../../helpers/alert";
import Calendar from "primevue/calendar";
import Download from "../../helpers/download";
import Loader from "../../helpers/loader";

export default {
  name: "ModalWaitingList",
  components: {SearchPatient, Dropdown, Calendar},
  props: ['currentProf', 'currentSpec'],
  emits: ['onCloseModal', 'onClickBtnCreateSchedule'],
  directives: {
    mask
  },
  data() {
    return {
      waitingLists: [],
      specialties: [],
      filterSpecialties: [],
      paymentMethods: [],
      insurances: [],
      placeInsurances: [],
      showFormStore: false,
      submiting: false,
      creatingOrUpdating: false,
      uniqueKey: Date.now(),
      selectedIds: [],
      notifying: false,
      filter: {
        id_prof: '',
        id_spec: '',
        id_insurance: '',
      },
      form: {
        wl_name: '',
        wl_cpf: '',
        wl_phone: '',
        id_patient: '',
        id_user: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: '',
        id_spec: '',
        id_place: '',
        wl_wait_at: '',
        wl_dt_birth: '',
        wl_obs: '',
        id_city: '',
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    isAllSelected() {
      return this.waitingLists.length > 0 && this.selectedIds.length === this.waitingLists.length;
    },
    isPartiallySelected() {
      return this.selectedIds.length > 0 && this.selectedIds.length < this.waitingLists.length;
    },
  },
  mounted() {
    Modal.onShow('#modal_waiting_list', () => {
      this.form.id_user = this.userAuth.id_user;
      this.form.id_prof = this.currentProf ?? this.userAuth.id_prof ?? '';
      this.form.id_spec = this.currentSpec ?? '';
      this.form.id_city = this.place.id_city;

      this.filter.id_prof = this.form.id_prof;
      this.filter.id_spec = this.form.id_spec;
      this.filter.id_insurance = '';
      this.selectedIds = [];

      this.onChangeProf(this.form.id_prof);
      this.loadFilterSpecialties(this.filter.id_prof);
      this.loadPlaceInsurances();
      this.getWaitingLists();
    });
    Modal.onClose('#modal_waiting_list', () => {
      this.resetForm();
      this.$emit('onCloseModal')
    });
  },
  methods: {
    date: moment,
    resetForm() {
      this.form = {
        wl_name: '',
        wl_cpf: '',
        wl_phone: '',
        id_patient: '',
        id_user: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: '',
        id_spec: '',
        id_place: '',
        wl_wait_at: '',
        wl_dt_birth: '',
        wl_obs: '',
        id_city: '',
      }
    },
    getWaitingLists() {
      http.get(`/places/${this.place.id_place}/waiting-lists`, {params: this.filter}).then((response) => {
        this.waitingLists = response.data;
        this.selectedIds = [];
      });
    },
    loadPlaceInsurances() {
      return http.get(`/places/${this.place.id_place}/insurances`).then((response) => {
        this.placeInsurances = response.data || [];
        return response;
      }).catch(() => {
        this.placeInsurances = [];
      });
    },
    onFilterProfChange(idProf) {
      this.filter.id_spec = '';
      this.loadFilterSpecialties(idProf);
      this.getWaitingLists();
    },
    loadFilterSpecialties(idProf) {
      if (!idProf) {
        this.filterSpecialties = [];
        return;
      }
      http.get(`/places/${this.place.id_place}/professionals/${idProf}/specialties`).then((response) => {
        this.filterSpecialties = response.data || [];
      }).catch(() => {
        this.filterSpecialties = [];
      });
    },
    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id);
      if (idx === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(idx, 1);
      }
    },
    toggleSelectAll() {
      if (this.selectedIds.length === this.waitingLists.length) {
        this.selectedIds = [];
      } else {
        this.selectedIds = this.waitingLists.map(w => w.id_wl);
      }
    },
    notifyWaitingLists() {
      if (this.selectedIds.length === 0 || this.notifying) return;

      Swal.fire({
        title: 'Avisar lista de espera',
        text: `Enviar o aviso de horário disponível para ${this.selectedIds.length} paciente(s) selecionado(s)?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim, avisar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.notifying = true;
        http.post(`/places/${this.place.id_place}/waiting-lists/notify`, {ids: this.selectedIds}).then((response) => {
          Alert.toastSuccess(response.data?.message ?? 'Avisos enviados.');
        }).catch((e) => {
          const data = e.response?.data;
          const message = typeof data === 'string' ? data : (data?.message ?? 'Erro ao enviar avisos.');
          Alert.toastError(message);
        }).finally(() => {
          this.notifying = false;
        });
      });
    },
    removeSelectedWaitingLists() {
      if (this.selectedIds.length === 0) return;
      Swal.fire({
        title: 'Remover selecionados',
        text: `Tem certeza que deseja remover ${this.selectedIds.length} paciente(s) da lista de espera?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const promises = this.selectedIds.map(id =>
            http.delete(`/places/${this.place.id_place}/waiting-lists/${id}`)
          );
          Promise.all(promises).then(() => {
            this.selectedIds = [];
            this.getWaitingLists();
            Alert.toastSuccess('Pacientes removidos com sucesso.');
          }).catch(e => {
            Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Erro ao remover.');
          });
        }
      });
    },
    onChangeProf(idProf) {
      if (!idProf)
        return;

      this.loadSpecialties(idProf);
      this.loadPaymentMethods(idProf);
      this.loadInsurances(idProf);
    },
    editWaitingList(waitingList) {
      this.resetForm();
      this.uniqueKey = Date.now()
      this.form = {
        ...patientIdentity(waitingList.patient || waitingList),
        id_wl: waitingList.id_wl,
        wl_name: waitingList.wl_name,
        wl_cpf: waitingList.wl_cpf,
        wl_phone: waitingList.wl_phone,
        id_patient: waitingList.id_patient,
        id_user: waitingList.id_user,
        id_insurance: waitingList.id_insurance,
        id_paymeth: waitingList.id_paymeth,
        id_prof: waitingList.id_prof,
        id_spec: waitingList.id_spec,
        id_place: waitingList.id_place,
        wl_wait_at: this.date(waitingList.wl_wait_at).format('DD/MM/YYYY'),
        wl_dt_birth: this.date(waitingList.wl_dt_birth).format('DD/MM/YYYY'),
        wl_obs: waitingList.wl_obs,
        id_city: waitingList.id_city,
      };

      document.getElementById('btnCollapseWaitingList').click();
    },
    scheduleFromWaitingList(waitingList) {
      this.$emit('onClickBtnCreateSchedule', waitingList);
      Modal.toggle('#modal_waiting_list');
    },
    removeWaitingList(id) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/waiting-lists/${id}`).then(_ => {
            this.getWaitingLists();

            Alert.toastSuccess("Paciente removido com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          });
        }
      });
    },
    onSubmit() {
      if (!this.form.wl_wait_at) {
        return Alert.toastWarning('Informe a data limite que o paciente ficará na lista de espera.');
      }

      if (!this.form.id_paymeth) {
        return Alert.toastWarning('Informe a forma de pagamento.');
      }

      if (!this.form.id_prof) {
        return Alert.toastWarning('Informe o profissional.');
      }

      if (!this.form.id_spec) {
        return Alert.toastWarning('Informe a especialidade.');
      }

      if (!this.form.wl_dt_birth) {
        return Alert.toastWarning('Informe a data de nascimento.');
      }

      if (this.form.id_wl) {
        http.put(`/places/${this.place.id_place}/waiting-lists/${this.form.id_wl}`, this.form).then(() => {
          this.getWaitingLists();
          this.resetForm();

          document.getElementById('btnCollapseWaitingList').click();

          Alert.toastSuccess("Lista de espera atualizada com sucesso.");
        }).catch(e => {
          Alert.toastError(e.response.data.message ?? e.response.data);
        });

        return;
      }

      http.post(`/places/${this.place.id_place}/waiting-lists`, this.form).then(() => {
        this.getWaitingLists();
        this.resetForm();

        document.getElementById('btnCollapseWaitingList').click();

        Alert.toastSuccess("Paciente adicionado com sucesso.");
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
      });

    },
    loadSpecialties(idProf) {
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/specialties`).then((response) => {
        this.specialties = response.data;
        if (this.specialties.length === 1) {
          this.form.id_spec = this.specialties[0].id_spec;
        }

        return response;
      });
    },
    loadPaymentMethods(idProf) {
      let params = {from_calendar: true}
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/payment-methods`, {params: params}).then((response) => {
        this.paymentMethods = response.data.filter(payMethod => payMethod.enabled_to_prof_place === 1 && ['BO', 'PL'].includes(payMethod.allowed_for));
        if (this.paymentMethods.length === 1) {
          this.form.id_paymeth = this.paymentMethods[0].id_paymeth;
        }

        return response;
      });
    },
    loadInsurances(idProf) {
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/insurances`).then((response) => {
        this.insurances = response.data.filter(insurance => insurance.enabled_to_prof_place === 1);
        return response;
      });
    },
    onClickSearchedPatient(patient) {
      Object.assign(this.form, patientIdentity(patient));
      this.form.wl_cpf = patient.patient_cpf || "";
      if (patient.patient_name)
        this.form.wl_name = patient.patient_name;
      if (patient.patient_cpf)
        this.form.wl_cpf = patient.patient_cpf;
      if (patient.id_patient)
        this.form.id_patient = patient.id_patient;
      if (patient.patient_phone)
        this.form.wl_phone = patient.patient_phone;
      if (patient.patient_birthdate_formatted)
        this.form.wl_dt_birth = patient.patient_birthdate_formatted;
      // Priorizar o primeiro convênio ativo válido, senão usar id_insurance_last
      let selectedInsuranceId = null;
      
      if (patient.id_insurance_active) {
        // Usar o primeiro convênio ativo válido
        selectedInsuranceId = patient.id_insurance_active;
      } else if (patient.id_insurance_last) {
        // Fallback: usar o último convênio usado
        selectedInsuranceId = patient.id_insurance_last;
      }
      
      if (selectedInsuranceId) {
        let exists = this.insurances.some(insurance => insurance.id_insurance === selectedInsuranceId);
        if (exists) {
          this.form.id_insurance = selectedInsuranceId;
        }
      }
    },
    allowInsurance() {
      if (!this.form.id_paymeth)
        return true;

      let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.form.id_paymeth);
      return paymentMethod?.is_insurance;
    },
    async exportWaitingList() {
      Loader.show('Gerando CSV', 'Aguarde');
      try {
        const response = await http.get(`/places/${this.place.id_place}/waiting-lists/export`, {
          params: {
            'id_prof': this.filter.id_prof,
            'id_spec': this.filter.id_spec,
            'id_insurance': this.filter.id_insurance,
          },
          responseType: 'blob'
        });

        Download.downloadCSV(response.data, 'lista_espera.csv');
      } catch (error) {
        Alert.toastError(error.response?.data?.message ?? error.response?.data ?? 'Erro ao exportar lista de espera');
      } finally {
        Loader.close();
      }
    },
  }
}
</script>

<style>
.p-calendar > .p-inputtext {
  border: none !important;
  background-color: #f5f8fa;
}

.waiting-list-table-scroll {
  max-height: min(60vh, 480px);
  overflow-y: auto;
  overflow-x: auto;
}
</style>